import api from './api.js';
import { ButtonSelector } from './script/button/button-selector';

api.button = {
  ButtonSelector: ButtonSelector
};

export default api;
